export default () => {
    const openMenuBtn = document.querySelector('.open-menu');
    const masthead = document.querySelector('#masthead');
    const mainNavigation = document.querySelector('.main-navigation');
    const body = document.querySelector('body');
    const backBtnWrp = document.querySelector('.back-btn-wrp');
    const primaryMenuItems = document.querySelectorAll('#primary-menu > .menu-item-has-children');
    const secondaryNavigation = document.querySelector('.secondary-navigation');
    const secondaryMenuItems = document.querySelectorAll('#secondary-menu > .menu-item-has-children');

    openMenuBtn.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.toggle('open');
        masthead.classList.toggle('open-submenu');
        mainNavigation.classList.toggle('open');
        body.classList.toggle('uk-overflow-hidden');
        backBtnWrp.style.display = this.classList.contains('open') ? 'block' : 'none';
        if(!openMenuBtn.classList.contains('open')){
            backBtnWrp.style.display = 'none';
            backBtnWrp.classList.remove('active-back');
        }
    });

    primaryMenuItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const menuItem = this.getAttribute('id');
            secondaryNavigation.classList.add('open');
            secondaryNavigation.style.display = 'block';
            document.querySelectorAll('#secondary-menu li').forEach(function(li) {
                li.classList.remove('active');
            });
            document.querySelectorAll('#secondary-menu li.' + menuItem).forEach(function(li) {
                li.classList.add('active');
            });
            document.querySelectorAll('#secondary-menu > .menu-item-has-children > .sub-menu > li').forEach(function(li) {
                li.style.display = 'block';
            });
            backBtnWrp.classList.add('active-back');
            backBtnWrp.style.display = 'block';
            backBtnWrp.setAttribute('data-back', this.getAttribute('class'));
            backBtnWrp.setAttribute('data-level', '1');
        });
    });

    document.querySelectorAll('#secondary-menu > .menu-item-has-children > .sub-menu > .menu-item-has-children > a').forEach(function(a) {
        a.addEventListener('click', function(e) {
            e.preventDefault();
        });
    });

    secondaryMenuItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
            const secMenuItem = this.getAttribute('class').replace(' active','').replaceAll(' ','.');
            document.querySelectorAll('#secondary-menu > .menu-item-has-children > .sub-menu > li').forEach(function(li) {
                li.style.display = 'none';
            });
            document.querySelectorAll('.'+secMenuItem+ ' > a').forEach(function(a) {
                a.style.display = 'none';
            });
            document.querySelectorAll('.'+secMenuItem).forEach(function(li) {
                li.style.display = 'block';
            });
            document.querySelectorAll('.'+secMenuItem+ ' > .sub-menu').forEach(function(submenu) {
                submenu.style.display = 'block';
            });
            backBtnWrp.classList.add('active-back');
            backBtnWrp.setAttribute('data-back', this.getAttribute('class'));
            backBtnWrp.setAttribute('data-level', '2');
        });
    });

    document.querySelectorAll('.back-btn-wrp').forEach(function(backBtn) {
        backBtn.addEventListener('click', function() {
            const removeActive = this.getAttribute('data-back').replace(/ /g, '.');
            if (this.getAttribute('data-level') === '1') {
                secondaryNavigation.classList.remove('open');
                secondaryNavigation.style.display = 'none';
                document.querySelectorAll('#secondary-menu > li').forEach(function(item) {
                    item.classList.remove('active');
                });
                document.querySelectorAll('.back-btn-wrp').forEach(function(btn) {
                    btn.style.display = 'none';
                    btn.setAttribute('data-level', 0);
                });
            } else if (this.getAttribute('data-level') === '2') {
                document.querySelectorAll('#secondary-menu > .menu-item-has-children.active > .sub-menu > li').forEach(function(item) {
                    item.style.display = 'block';
                });
                document.querySelectorAll('.' + removeActive + ' > a').forEach(function(a) {
                    a.style.display = 'block';
                });
                document.querySelectorAll('.' + removeActive).forEach(function(item) {
                    item.style.display = 'block';
                });
                document.querySelectorAll('.' + removeActive + ' > .sub-menu').forEach(function(subMenu) {
                    subMenu.style.display = 'none';
                });
                this.setAttribute('data-level', 1);
            }
        });
    });

    document.querySelector('html').addEventListener('click', function(e) {
        if (!e.target.closest('.secondary-navigation') && !e.target.closest('.main-navigation')) {
            document.querySelectorAll('#primary-menu > li').forEach(function(item) {
                item.classList.remove('open');
            });
            document.querySelector('#masthead').classList.remove('open-submenu');
            secondaryNavigation.classList.remove('open');
            document.querySelectorAll('.secondary-navigation').forEach(function(nav) {
                nav.style.display = 'none';
            });
            document.querySelectorAll('#secondary-menu li').forEach(function(item) {
                item.classList.remove('active');
            });
        }
    });

    const anchors = document.querySelectorAll('a[href*="#"]')

    for (let anchor of anchors) {
        anchor.addEventListener('click', function (e) {
            e.preventDefault()
            const blockID = anchor.getAttribute('href').substr(1)
            if(document.getElementById(blockID)){
                document.getElementById(blockID).scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        })
    }
};

